const CSV = {
    download() {
        OVERLAY.loading();
        var csv = 'ID,Status,Fragebogen Code versendet am,Fragebogen ausgefüllt am,Profil zugesagt bis,Angenommen von Scorer:in,Profil erstellt am,Profil Download Link,Anrede,Nachname,Vorname,E-Mail-Adresse,Code,Berater ID,Berater Nachname,Berater Vorname,Berater E-Mail-Adresse,Beantwortungsdauer des Fragebogens\n';
        csvData.forEach(row => {
                csv += row.join(',');
                csv += '\n';
        });
        console.log(csv);
        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'uebersicht-i_e_profile.csv';
        hiddenElement.click();
        setTimeout(() => {
            document.getElementById('overlay-loading').remove();
        }, 500);
    }
}

